import { BitfPEnvelopeMapper } from '@bitf/core/parsers/p-parser';

export class AppEnvelopeMapper extends BitfPEnvelopeMapper {}
